<template>
    <main class="page-content min-height">
      <!-- Contact us -->
      <section class="well--inset-7 text_center_small">
        <div class="container relative">
          <div class="row offset-2">
            <div class="col-md-9">
              <!-- RD Google Map -->
              <app-map></app-map>
              <!-- END RD Google Map -->
            </div>
          </div>
          <div class="row flow-offset-4">
            <div class="col-sm-12 col-sm-preffix-1">
              <div class="box-2 box-md-absolute box-white text-md-left inset-3">
                <h2>Contact us</h2>
                <address class="contact-info md-absolute bg-contrast">
                  <dl>
                    <dt class="heading-5 text-default">Address</dt>
                    <dd><p class="md-visible">110-56 Queens Boulevard<br>Forest Hills,NY 11375</p></dd>
                  </dl>
                  <dl>
                    <dt class="heading-5 text-default">Telephone</dt>
                    <dd><a href="callto:#">718 520 0911</a></dd>
                  </dl>
                </address><br>
                <h3>Free Consultation</h3>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!-- END Contact us-->
    </main>
</template>

<script>
  import Map from './Map'
  export default {
    name: 'ContactUs',
    components: {
      'app-map': Map,
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1 {
  display: block;
  margin: 0 auto;
}
</style>
